import * as React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Container, Typography } from "@mui/material";
import Box from "@mui/material/Box";
import BottomNavigation from "@mui/material/BottomNavigation";
import BottomNavigationAction from "@mui/material/BottomNavigationAction";

import img1 from "../../../Images/OS_3_WWW_Home_2c.jpg";
import img2 from "../../../Images/OS_3_WWW_Home_2d.jpg";
import img3 from "../../../Images/OS_3_WWW_Home_2e.jpg";

import icon1 from "../../../Images/Icon/3.webp";
import icon2 from "../../../Images/Icon/4.webp";
import icon3 from "../../../Images/Icon/5.webp";

const images = [img1, img2, img3];

export default function ButtonNavigationSection() {
  const [value, setValue] = React.useState(0);
  const [currentImage, setCurrentImage] = React.useState(images[0]);

  React.useEffect(() => {
    setCurrentImage(images[value]);
  }, [value]);

  return (
    <Box sx={{ py: 7, position: "relative" }} height="800px">
      <Box
        sx={{
          position: "absolute",
          top: "0",
          left: "0",
          zIndex: "-10",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <AnimatePresence mode="popLayout">
          <motion.img
            key={currentImage}
            className="w-full h-full object-cover object-right"
            src={currentImage}
            alt=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          />
        </AnimatePresence>
      </Box>

      <Container
        sx={{
          maxWidth: { xs: "100%" },
          px: { xl: 10 },
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100%",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: { xs: 1, md: 3 },
          }}
        >
          <Typography
            variant="button"
            fontSize={{ lg: 16, xl: 18 }}
            fontWeight={300}
            color="white"
          >
            Smart home | Personalization
          </Typography>
          <Typography
            variant="h2"
            textTransform="uppercase"
            color="white"
            fontSize={{ xs: 36, sm: 40, md: 50, xl: 60 }}
          >
            You're In Control
          </Typography>
          <Typography
            width={{ md: "74%", lg: "50%" }}
            fontSize={{ lg: 16, xl: 18 }}
            fontWeight={300}
            color="white"
          >
            MEETFUTUR OS 3 puts more capabilities, features, and benefits at
            your fingertips. With touchscreen, keypad, voice, and app access,
            you can create a smart home that’s uniquely yours.
          </Typography>
        </Box>

        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
            gap: 3,
          }}
        >
          <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            sx={{
              display: { xs: "none", md: "flex" },
              backgroundColor: "transparent",
              width: { md: 290, lg: 310, xl: 350 },
              mb: 3,
            }}
          >
            <BottomNavigationAction
              disableelevation="true"
              disableRipple
              value={0}
              icon={
                <img
                  alt=""
                  src={icon1}
                  className={`hover:bg-[#8a1321] hover:border-[#8a1321] border transition-all rounded-full ${
                    value === 0
                      ? "bg-[#8a1321] border-[#8a1321]"
                      : "border-white"
                  }`}
                />
              }
            />
            <BottomNavigationAction
              disableelevation="true"
              disableRipple
              value={1}
              icon={
                <img
                  alt=""
                  src={icon2}
                  className={`hover:bg-[#8a1321] hover:border-[#8a1321] border transition-all rounded-full ${
                    value === 1
                      ? "bg-[#8a1321] border-[#8a1321]"
                      : "border-white"
                  }`}
                />
              }
            />
            <BottomNavigationAction
              disableelevation="true"
              disableRipple
              value={2}
              icon={
                <img
                  alt=""
                  src={icon3}
                  className={`hover:bg-[#8a1321] hover:border-[#8a1321] border transition-all rounded-full ${
                    value === 2
                      ? "bg-[#8a1321] border-[#8a1321]"
                      : "border-white"
                  }`}
                />
              }
            />
          </BottomNavigation>

          <Typography
            width={{ md: "74%", lg: "50%" }}
            fontSize={{ lg: 16, xl: 18 }}
            fontWeight={300}
            color="white"
          >
            Add your favorites to your home screen for every room in the
            house—such as a lighting scene, garage door, smart door locks, or a
            playlist. Customize your wallpapers for every space with family
            photos or designer-influenced wallpapers that blend with the decor
            of your home.
          </Typography>
          {/* <Button variant="outlined">Learn More About Smart Home OS 3</Button> */}
        </Box>
      </Container>
    </Box>
  );
}
